import React from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { stringifyUrl } from 'query-string';

const GoogleStaticMap = ({
  alt,
  apiKey,
  url,
  center,
  width,
  height,
  zoom,
  markers,
  options = {},
  ...props
}) => {
  const src = stringifyUrl({
    url,
    query: {
      key: apiKey,
      center,
      size: `${width}x${height}`,
      zoom,
      markers,
      scale: 2,
      ...options,
    },
  });

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      quality={100}
      unoptimized="true"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};

GoogleStaticMap.propTypes = {
  alt: PropTypes.string.isRequired,
  apiKey: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  center: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  zoom: PropTypes.number.isRequired,
  markers: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.object,
};

export default GoogleStaticMap;
